import { render, staticRenderFns } from "./law_category.vue?vue&type=template&id=ca4cfd30&scoped=true&"
import script from "./law_category.vue?vue&type=script&lang=js&"
export * from "./law_category.vue?vue&type=script&lang=js&"
import style0 from "./law_category.vue?vue&type=style&index=0&id=ca4cfd30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4cfd30",
  null
  
)

export default component.exports